import * as Room from '../services/room';
import * as Equipment from '../services/equipment';
import * as Booking from '../services/booking';
import * as Auth from '../services/auth';
import * as Setting from '../services/setting';
import * as Upload from '../services/upload';
import * as History from '../services/history';
import * as Form from '../services/form';
import * as Review from '../services/review';
import * as Manage from '../services/manage';
import * as News from '../services/news';
import * as ExportExcel from '../services/exportExcel';

export const RoomService = Room;
export const EquipmentService = Equipment;
export const BookingService = Booking;
export const AuthService = Auth;
export const SettingService = Setting;
export const UploadService = Upload;
export const HistoryService = History;
export const FormService = Form;
export const ReviewService = Review;
export const ManageService = Manage;
export const NewsService = News;
export const ExportExcelService = ExportExcel;
